import cls from 'clsx';
import PlayIcon from "../../../public/images/icons/video/play.svg";
import { BunnyCdnImage } from "../../Image/BunnyCdnImage";
import { useEffect, useRef } from "react";
import { useGallery } from '../../../hooks/useGallery';
import { MediaType } from '@jconradi/tutu-porn-api-client/src/media';

export const GalleryThumbnails = ({ index, setIndex, media }: any) => {
    const galleryQuery = useGallery(media.gallery!);
    const ref = useRef<any>();

    // Scroll horizontal list to right gallery item when index changes.
    useEffect(() => {
        const el = ref.current?.children[index];

        if (!el) {
            return;
        }

        const elLeft = el.offsetLeft + el.offsetWidth;
        const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
      
        // check if element not in view
        if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
          el.parentNode.scrollLeft = elLeft - elParentLeft;
        } else if (elLeft <= el.parentNode.offsetLeft + el.parentNode.scrollLeft) {
          el.parentNode.scrollLeft = el.offsetLeft - el.parentNode.offsetLeft;
        }
    }, [index]);

    return (
        <div className="p-4 absolute bottom-0 left-0 right-0 w-full">
                <div ref={ref} className="h-[48px] items-center flex flex-row gap-x-2 overflow-x-auto">
                    {galleryQuery.data?.data.media.map((m, currentIdx) => {
                        const className = cls(`cursor-pointer border-[3px] w-full rounded-lg overflow-hidden`, {
                            ['border-primary']: currentIdx === index,
                            ['border-transparent']: currentIdx !== index
                        });

                        return (
                            <div key={m.slug} className="relative">
                                <BunnyCdnImage width={48} height={48} onClick={() => setIndex(currentIdx)} alt={`gallery thumbnail for ${m.slug}`} src={m.urls.poster}
                                    className={cls("object-cover h-[48px] w-auto min-w-[36px]", className)} />
                                {m.mediaType === MediaType.Video &&
                                    <PlayIcon className="absolute pointer-events-none top-1/2 left-1/2 w-4 h-4 -translate-x-1/2 -translate-y-1/2" />
                                }
                            </div>
                        )
                    })}
                </div>
            </div>
    )
}